import { MkgOS } from "@app/class/mkg-os";
import { RO_STATES } from "@app/shared/lists/ro-states";

export enum RO_LOG_ACTION_TYPES {
  CREATE = 0,
  REQUEST_AUTHORIZATION,
  AUTHORIZE,
  UPDATE_RO,
  ISSUE_INVOICES,
  APPROVE_SUPPLEMENTARY_BUDGET,
  REJECT_SUPPLEMENTARY_BUDGET,
  OPEN,
  CLOSE,
  RETURN_TO_BUDGET,
  ADD_COMMON_CHECKLIST_TO_OS,
  UPDATE_RO_PART_DISCOUNT,
  UPDATE_RO_LABOR_DISCOUNT,
  UPDATE_RO_DISCOUNT,
  UPDATE_COMMON_CHECKLIST_INTO_OS,
  UPDATE_COMMON_CHECKLIST_ITEM_TO_OS,
  FINISH_CHECKLIST_BY_MODEL,
  ADD_PART,
  UPDATE_PART,
  REMOVE_PART,
  ADD_LABOR,
  UPDATE_LABOR,
  REMOVE_LABOR,
  ADD_THIRD_PARTY_SERVICES,
  EDIT_THIRD_PARTY_SERVICES,
  REMOVE_THIRD_PARTY_SERVICES,
  ADD_OR_UPDATE_PART_TMP,
  REMOVE_PART_TEMP,
  ADD_OR_UPDATE_LABOR_TMP,
  REMOVE_LABOR_TEMP,
  SAVE_BREAKDOWNS,
  ADDED_CARTE
}

export interface ILogOS {
  _id?: string;
  company: string;
  osId: string;
  invoicesRelated?: Array<{
    invoiceId: string;
    invoiceNumber: string;
  }>;
  userId: string; 
  reason?: string;
  actionType: RO_LOG_ACTION_TYPES;
  statusInTheLogRecord: RO_STATES;
  updatedFields?: Array<{
    fieldName: string;
    newValue: any;
    oldValue: any;
  }>;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface IPaginatedLogOS extends ILogOS {
  userData: {
    kind: "User";
    name: string;
    email: string;
    _id: string;
  };
  osData: {
    budgetCode: number;
    codeSystem: number;
  }
}
 
export interface ILogOSPost {
  osId: string;
  invoicesRelated?: Array<{
    invoiceId: string;
    invoiceNumber: string;
  }>;
  userId: string; 
  reason?: string;
  actionType: number;
  statusInTheLogRecord: number;
  updatedFields?: Array<{
    fieldName: string;
    newValue: any;
    oldValue: any;
  }>;
}

export interface ILogOSCreateParams {
  osId: string; 
  invoicesRelated?: Array<{
    invoiceId: string;
    invoiceNumber: string;
  }>;
  reason?: string;
  actionType: RO_LOG_ACTION_TYPES;
  statusInTheLogRecord: RO_STATES;
  updatedFields?: Array<{
    fieldName: keyof MkgOS;
    newValue: any;
    oldValue: any;
  }>;
}